import { useQuery } from 'react-query'

import { Transaction } from '@features/transactions/types/transaction'

import { defaultStaleTime } from '../../../../../config/queryClient'
import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchTransaction } from '../../../query-api'

interface UseFetchTransactionProps {
  transactionId?: string
}

interface UseFetchTransactionResponse {
  isLoading: boolean
  transaction: Transaction | undefined
}

export const useFetchTransaction = ({ transactionId }: UseFetchTransactionProps): UseFetchTransactionResponse => {
  const { data, isLoading } = useQuery(
    [QueryKeys.Transaction, transactionId],
    () => fetchTransaction(transactionId as string),
    {
      enabled: !!transactionId,
      staleTime: defaultStaleTime,
      suspense: true,
    },
  )

  return {
    isLoading,
    transaction: data?.transaction,
  }
}
